import { Typo } from "../../Typo";
import { useClientTradingReportContext } from "../ClientTradingReport";
import { ReturnedTranslatedContentClientsPageHook } from "../types";
import { useDateRange } from "./utils/useDateRange";

export const ClientTableDescription = ({
  translations,
  isMobileBottomSheetEnable,
}: {
  translations: ReturnedTranslatedContentClientsPageHook;
  isMobileBottomSheetEnable?: boolean;
}) => {
  const {
    state: { dateRange },
  } = useClientTradingReportContext();

  const dateTitle = useDateRange(dateRange, translations.language);
  const title = `${translations.translatedContent.tradingReportTab?.tradingTableDescription}: ${dateTitle}`;

  return (
    <div
      className={`flex flex-row items-center justify-between ${isMobileBottomSheetEnable ? "mb-3 mt-4 lg:mb-6 lg:mt-10" : "mb-6 mt-10"}`}
    >
      <Typo type="bodyMD" smType="bodySM" textColor="text-text-secondary">
        {title}
      </Typo>
    </div>
  );
};
